import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { createSlice } from '@reduxjs/toolkit';
import {
  accessTokenCookieName,
  NODE_ENV,
  refreshTokenCookieName,
} from '../lib/constants';
import Cookies from 'js-cookie';

// Initial State
const initialState = {
  userDetails: {},
  token: null,
  isAuthenticated: false,
};

// Auth Slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logIn: (state, { payload }) => {
      return {
        ...state,
        userDetails: payload,
        token: payload.token,
        isAuthenticated: true, // Ensure proper boolean handling
      };
    },
    logout: (state) => {
      state.userDetails = null;
      state.token = null;
      state.isAuthenticated = false;
      Cookies.remove(accessTokenCookieName);
      Cookies.remove(refreshTokenCookieName);
      localStorage.removeItem('user');

      // window.location.href = '/';
    },
    setUserBCA: (state, { payload }) => {
      if (state.userDetails) {
        state.userDetails.bca = payload;
      }
    },
    setUserBCAConfigurations: (state, { payload }) => {
      if (state.userDetails) {
        state.userDetails.bca.configurations = payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase(() => {});
  },
});

const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token', 'userDetails', 'isAuthenticated'], // Persist only necessary state
};

const persistedReducer = persistReducer(persistConfig, authSlice.reducer);

export const store = configureStore({
  reducer: {
    auth: persistedReducer, // Use named reducer for better scalability
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

// Action Creators
export const { logIn, logout, setUserBCA, setUserBCAConfigurations } =
  authSlice.actions;

// Custom Hooks
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
